<template>
	<div>
		<FormInput
			name="firstName"
			label="First Name"
			:small="true"
			:compact="true"
			:hasError="$v.firstName.$error"
			:errorMessage="firstNameError"
			v-model="firstName"
		/>
		<FormInput
			name="lastName"
			label="Last Name"
			:small="true"
			:compact="true"
			:hasError="$v.lastName.$error"
			:errorMessage="lastNameError"
			v-model="lastName"
		/>
		<FormInput
			name="email"
			label="Email"
			type="email"
			:small="true"
			:compact="true"
			:hasError="$v.email.$error"
			:errorMessage="emailError"
			v-model="email"
		/>
		<FormInput
			name="phone"
			label="Phone"
			type="tel"
			:small="true"
			:compact="true"
			:hasError="$v.phone.$error"
			:errorMessage="phoneError"
			v-model="phone"
		/>
		<div class="form-group is-small is-compact" :class="{'has-error' : $v.password.$error}">
			<PasswordField :name="'signup_password'" v-model="password" />
			<FormError :error="$v.password.$error" :message="passwordError" />
		</div>
	</div>
</template>

<script>
import PasswordField from "@/components/formfields/FlytPasswordField"
import FormInput from "@/components/formfields/FormInput"
import FormError from "@/components/formfields/FormError"
import { required, email, numeric } from "vuelidate/lib/validators"
import { emailAvailable, passwordLength, phoneLength } from "@/utils/validators"
import { mapState } from "vuex"

export default {
	name: "SignUpForm",

	data() {
		return {
			firstName: "",
			lastName: "",
			email: "",
			phone: "",
			password: "",
			showPassword: false,
		}
	},

	components: { PasswordField, FormInput, FormError },

	validations: {
		firstName: { required },
		lastName: { required },
		email: {
			required,
			email,
			emailAvailable,
		},
		phone: {
			required,
			numeric,
			phoneLength,
		},
		password: {
			required,
			passwordLength,
		},
	},

	computed: {
		...mapState("auth", ["authenticationErrorCode"]),

		firstNameError() {
			let errorMessage = "Invalid input"
			if (!this.$v.firstName.required) errorMessage = "Please enter your first name"
			return errorMessage
		},

		lastNameError() {
			let errorMessage = "Invalid input"
			if (!this.$v.lastName.required) errorMessage = "Please enter your last name"
			return errorMessage
		},

		emailError() {
			let errorMessage = "Invalid input"
			if (!this.$v.email.email) errorMessage = "Must be a valid email address"
			if (!this.$v.email.required) errorMessage = "Email address is required"
			if (!this.$v.email.emailAvailable) errorMessage = "This email has already been registered"
			return errorMessage
		},

		phoneError() {
			let errorMessage = "Invalid input"
			if (!this.$v.phone.phoneLength) errorMessage = this.$v.phone.$params.phoneLength.message
			if (!this.$v.phone.required) errorMessage = "Phone number is required"
			return errorMessage
		},

		passwordError() {
			let errorMessage = "Invalid input"
			if (!this.$v.password.passwordLength) errorMessage = this.$v.password.$params.passwordLength.message
			if (!this.$v.password.required) errorMessage = "Password is required"
			return errorMessage
		},
	},
}
</script>

<style lang="scss" scoped></style>
